import { render, staticRenderFns } from "./CommodityPicker.vue?vue&type=template&id=4fc63cfd&"
import script from "./CommodityPicker.vue?vue&type=script&lang=js&"
export * from "./CommodityPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/data/jenkins/workspace/booking-fe-stg/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fc63cfd')) {
      api.createRecord('4fc63cfd', component.options)
    } else {
      api.reload('4fc63cfd', component.options)
    }
    module.hot.accept("./CommodityPicker.vue?vue&type=template&id=4fc63cfd&", function () {
      api.rerender('4fc63cfd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/local/vsl/CommodityPicker.vue"
export default component.exports